import { Link } from "react-router-dom";
import { Box } from "lucide-react";

export const Nav = () => {
  return (
    <nav
      data-testid="main-nav"
      className="fixed top-0 left-0 w-full z-50 backdrop-blur-xl bg-white/75 border-b border-neutral-200/60"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <div className="w-7 h-7 bg-[#FF4F00] flex items-center justify-center">
            <Box className="w-4 h-4 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-display font-bold text-lg tracking-tight">
            TOTEHAUL
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-10 text-sm font-medium text-neutral-700">
          <a href="#tiers" data-testid="nav-link-tiers" className="hover:text-[#FF4F00] transition-colors">Tiers</a>
          <a href="#how" data-testid="nav-link-how" className="hover:text-[#FF4F00] transition-colors">How it works</a>
          <a href="#faq" data-testid="nav-link-faq" className="hover:text-[#FF4F00] transition-colors">FAQ</a>
        </div>

        <a
          href="#tiers"
          data-testid="nav-cta"
          className="bg-[#0A0A0A] text-white px-5 py-2.5 text-sm font-semibold tracking-wide hover:bg-[#FF4F00] transition-colors"
        >
          Reserve now
        </a>
      </div>
    </nav>
  );
};
